/* eslint-disable prefer-const */
import { useEffect, useState } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { uniqueId } from 'lodash';
import useDebounce from 'src/hooks/useDebounce';
import RemoveNullObjectValue from 'src/utils/RemoveNullObjectValue';

import RHFTextField from '../../../components/hook-form/RHFTextField';
import FormProvider from '../../../components/hook-form/FormProvider';

import validation from './validation';
// import RHFSelectStatic from '../../../components/hook-form/RHFSelectStatic';
import RHFDatePicker from '../../../components/hook-form/RHFDatePicker';
import Enum from '../enum';
import { useMutationCustom, useQueryCustom } from '../../../utils/reactQueryHooks';
import axiosInstance from '../../../utils/axios';
import { fDateApi, fDateForApi } from '../../../utils/formatTime';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import persianToEnglishNumber from '../../../utils/persianToEnglishNumber';
import WaitingBox from '../../../components/WaitingBox/index';
import RHFRadioGroups from 'src/components/hook-form/RHFRadioGroups';
import { GENDER_DEFAULT_OP } from 'src/config';
import ProvinceSelector from 'src/components/selector/Province';


const Add = ({ onClose }) => {
  const defaultAgents = [
    // {
    //   agent: {
    //     value: agentsType.managerCaravan.value,
    //     label: 'مدیر کاروان',
    //   },
    //   admin: null,
    //   keyId: uniqueId(),
    // },
    // {
    //   agent: {
    //     value: agentsType.rohani.value,
    //     label: 'روحانی کاروان',
    //   },
    //   admin: null,
    //   keyId: uniqueId(),
    // },
  ];

  const { t } = useTranslation();
  const queryParams = useParams();
  const paramId = queryParams?.id;

  const navigate = useNavigate();
  const [CreateInputsArr, setCreateInputsArr] = useState([])

  const backUrl = `${Enum.routes.root(queryParams.type, queryParams.travel)}`;
  const methods = useForm({
    resolver: yupResolver(validation.schema()),
    // mode: 'onChange',
    mode: 'all',
    shouldUnregister: false,
    defaultValues: {
      dispatch_date: "",
      period_from: new Date(),
      period_to: new Date(),
      meeting_date: "",
      agents: defaultAgents,
      men_count: 0,
      women_count: 0,
      married_count: 0,
    },

    // defaultValues: {
    //   active: 1,
    //   address: 'آدرس',
    //   baj_number: '12',
    //   border: 'سشیشسی',
    //   border_code: '23151',
    //   capacity: '10',
    //   deputy_id: 4,
    //   dispatch_date: '1403-03-16',
    //   flight_station: '123',
    //   interface_id: 4,
    //   iran_province_id: 6,
    //   is_lottery: 1,
    //   manager_id: 3,
    //   meeting_date: '1403-03-17',
    //   period_from: '1403-03-18',
    //   period_to: '1403-03-29',
    //   price: '200000',
    //   rohani_id: 4,
    //   storage_capacity: '2',
    //   storage_max: '15',
    //   team_grade: '10',
    //   team_type: 0,
    //   university_category_id: 3,
    //   university_id: 3,
    //   woman_rohani_id: 3,
    // },
  });

  const {
    reset,
    watch,
    control,
    setValue,
    setError,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
    trigger,
  } = methods;

  // ----------------------------------------------------------------------------- SERVICE
  const creating = (params) => axiosInstance.post(Enum?.api?.base, params);
  const updating = (params) => axiosInstance.put(`${Enum?.api?.base}/${paramId}`, params);
  const getById = () => axiosInstance.get(`${Enum?.api?.base}/${paramId}`);
  // ------------------------------------------------------------------------------ Mutation
  const onSuccessMutating = () => {
    toast.success(t('successfully'));
    navigate(backUrl);
  };
  // const onErrorMutating = (error) => {
  //   console.log('* * * onErrorMutating :', { error });
  //   const errorTitle = error.response.data.message || t('errorTryAgain');
  //   const errors = Object.values(error?.response?.data?.errors || {});
  //   if (errors?.length) {
  //     errors?.map((x) => {
  //       return toast.error(x?.[0]);
  //     });
  //   } else toast.error(errorTitle);
  // };
  const { isLoading, mutate } = useMutationCustom({
    url: paramId ? updating : creating,
    name: `${Enum?.api?.base}_update`,
    invalidQuery: `${Enum?.api?.base}_get`,
    onSuccess: onSuccessMutating,
    // onError: onErrorMutating,
  });
  // ---------------------------------------
  const onSuccess = (resData) => {
    console.log('* * * onSuccess', { resData });

    const resetData = {
      [validation.fieldNames.gender]: resData?.data?.data?.[validation.fieldNames.gender] ? { label: resData?.data?.data?.[validation.fieldNames.gender], value: resData?.data?.data?.[validation.fieldNames.gender] } : "",
      [validation.fieldNames.iran_province_id]: ProvinceSelector.convertor.object(resData?.data?.data?.province),
      ...(resData?.data?.data?.date && {
        [validation.fieldNames.dispatch_date]: resData?.data?.data?.date,
      }),
    };

    console.log('* * * onSuccess', { resetData });
    reset(resetData);
    //
  };
  const dataById = useQueryCustom({
    name: `get_by_Id_${Enum?.api?.base}_${paramId}`,
    url: getById,
    onSuccess: onSuccess,
    enabled: !!paramId,
  });

  useEffect(() => {
    if (!dataById?.data?.data) return;
    console.log('* * * aaaaaaaa dataById: ');
    onSuccess(dataById?.data);
  }, [dataById?.data?.data]);

  const watchStartDate = watch(validation.fieldNames.startDate);
  console.log({ watchStartDate });
  const onSubmit = async () => {
    const values = getValues();
    console.log('* * * onSubmit : ', { values });


    let reqData = {
      [validation.fieldNames.travel_id]: +queryParams.travel,
      [validation.fieldNames.gender]: values[validation.fieldNames.gender]?.value,
      [validation.fieldNames.iran_province_id]: values[validation.fieldNames.iran_province_id]?.value,
      [validation.fieldNames.dispatch_date]: values[validation.fieldNames.dispatch_date] ? persianToEnglishNumber(
        (values[validation.fieldNames.dispatch_date])
      ) : undefined,
    };



    console.log({ queryParams, travel_id: validation.fieldNames.travel_id, reqData });
    reqData = RemoveNullObjectValue(reqData);
    const formData = new FormData();
    Object.keys(reqData || {})?.map((x) => {
      let value = ![null].includes(reqData[x]) ? reqData[x] : '';
      formData.append(x, value);
    });

    // if (!paramId) {
    //   reqData.inputs = [];
    //   for (let i = 0; i < CreateInputsArr.length; i += 1) {
    //     const element = CreateInputsArr[i];
    //     console.log({ element })
    //     formData.append(`inputs[${i}][type]`, element?.type);
    //     formData.append(`inputs[${i}][label]`, element?.label);
    //     formData.append(`inputs[${i}][value]`, element?.value);
    //     formData.append(`inputs[${i}][options]`, element?.options);
    //   }
    // }
    // if (paramId) {
    //   formData.append('_method', 'put');
    // }



    console.log('* * * onSubmit : ', { reqData, values });
    // mutate(formData);
    mutate(reqData);
  };
  console.log({ queryParams, dataById, errors });

  const { debounce } = useDebounce({
    setDebounce: () =>
      trigger([
        validation.fieldNames.men_count,
        validation.fieldNames.women_count,
        validation.fieldNames.married_count,
        validation.fieldNames.capacity,
      ]),
  });

  const triggerCount = () => {
    debounce();
  };

  return dataById.isLoading ? (
    <WaitingBox />
  ) : (
    <Box
      sx={{
        width: '100%',
        // display: { xs: 'block', md: 'flex' },
        gap: 2,
        bgcolor: 'background.paper',
        borderRadius: 1,
        p: 4,
      }}
    >
      <HeaderBreadcrumbs
        back={`${Enum.routes.root(queryParams.type, queryParams.travel)}`}
        heading={
          paramId ? t('editAuthor', { author: Enum.title.name[0] }) : t('addAuthor', { author: Enum.title.name[0] })
        }
      >
        {/* <Typography sx={{ mt: 1 }}>{resQuery?.data?.data?.name}</Typography> */}
      </HeaderBreadcrumbs>


      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          <Grid container spacing={3}>

            <Grid item xs={12} md={6}>
              <RHFTextField name={validation.fieldNames.dispatch_date} label={'تاریخ اعزام'} required/>
            </Grid>

            <Grid item xs={12} md={6}>
              <ProvinceSelector.Element name={validation.fieldNames.iran_province_id} label={'استان'} required/>
            </Grid>

            <Grid item xs={12} md={6}>
              <RHFRadioGroups
                options={GENDER_DEFAULT_OP}
                name={validation.fieldNames.gender}
                label={"جنسیت"}
                required
              />
            </Grid>




          </Grid>
        </Box>

        <Box
          sx={{
            display: 'flex',
            mt: 3,
            gap: 3,
            justifyContent: 'center',
          }}
        >
          {/* <LoadingButton
            fullWidth
            // type="click"
            variant="outlined"
            color="success"
            loading={isLoading}
            onClick={onClose}
          >
            {'لغو'}
          </LoadingButton> */}

          <LoadingButton type="submit" variant="contained" color={'success'} loading={isLoading}>
            {'ثبت اطلاعات'}
          </LoadingButton>
        </Box>
      </FormProvider>
    </Box>
  );
};

export default Add;
